<template>
  <div>
    <div class="bg" style="padding-bottom: 20px">
      <FxedTop ref="fxedTop"></FxedTop>
    </div>
    <div class="page">
      <div class="pageTitle">
        <div class="sort"></div>
        <div class="currentLocation">当前位置：首页 > 课程小节详情</div>
      </div>
      <div class="container">
        <div class="containent">
          <div class="bannerContainer">
            <img :src="querybg" class="banner" />
            <div class="person">
              <img :src="query" class="avaUrl" />
              <div class="nicName">
                <div>{{ queryList.name }}</div>
                <div>
                  共{{ queryList.typeConfig.length }}道题 |
                  {{ queryList.completePeople || 0 }}人答过
                </div>
              </div>
            </div>
          </div>
          <div class="main">
            <!-- 题目和选项 -->
            <div
              class="items"
              v-for="(item, index) in queryList.typeConfig"
              :key="index">
              <div class="" style="background: #aacd22; border-radius: 15px">
                <div class="title">{{ item.title }}</div>
              </div>
              <div
                v-for="(professionitem, key) in item.options"
                :key="key"
                class="opt"
                :class="
                  (key == item.options.length - 1 &&
                    item.otherOption == 1 &&
                    professionitem.isShow &&
                    submitStatus) ||
                  (submitStatus && professionitem.option_right == 1)
                    ? 'opt_on'
                    : ''
                ">
                <div class="" @click="changeItem(item, professionitem)">
                  <div class="checkedImg" style="">
                    <block v-if="queryList.type == 4 && submitStatus">
                      <block
                        v-if="
                          key == item.options.length - 1 &&
                          item.otherOption == 1 &&
                          professionitem.isShow
                        ">
                        <img
                          v-if="professionitem.isShow"
                          src="@/assets/images/dddh.png"
                          class="checked" />
                      </block>
                      <block v-else>
                        <img
                          v-if="
                            professionitem.isShow &&
                            professionitem.option_right == 1
                          "
                          src="@/assets/images/dddh.png"
                          class="checked" />
                        <img
                          v-if="
                            !professionitem.isShow &&
                            professionitem.option_right == 1
                          "
                          src="@/assets/images/ddd.png"
                          class="checked" />
                        <img
                          v-if="
                            professionitem.isShow &&
                            professionitem.option_right != 1
                          "
                          style="margin-left: -6px"
                          src="@/assets/images/xxx.png"
                          class="checked" />
                      </block>
                    </block>

                    <block v-else>
                      <img
                        v-if="professionitem.isShow"
                        src="@/assets/images/dddh.png"
                        class="checked" />
                    </block>
                  </div>
                  <img :src="defaultcircle" class="check" />
                </div>
                <!-- <div style="flex:1" class="" v-if="key==item.options.length-1"> -->
                <div
                  style="flex: 1"
                  class=""
                  v-if="
                    item.otherOption == 1 && key == item.options.length - 1
                  ">
                  <input
                    type="text"
                    :placeholder="professionitem.option"
                    :data-index="index"
                    :data-key="key"
                    @input="input_ot" />
                </div>
                <div v-else style="flex: 1">{{ professionitem.option }}</div>
              </div>
            </div>
            <div class="tips">
              {{ queryList.tips }}
            </div>
            <!-- 提交按钮 -->
            <div v-if="!submitStatus" class="submit" @click="submit">提交</div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { IMAGES_PATH } from "@/utils/config2.js";
import { sectionInfo, sectionComplete } from "@/api/wkApi.js";
import Footer from "@/components/Footer";

import FxedTop from "@/components/FxedTop";

export default {
  components: {
    FxedTop,
    Footer,
  },
  data() {
    return {
      images1: IMAGES_PATH + "/images/yuan.png",
      gu1: IMAGES_PATH + "/images/animate/luan_1.png",
      rightbg: IMAGES_PATH + "/images/microlecture/rightbg.png",
      defaultcircle: IMAGES_PATH + "/images/microlecture/defaultcircle.png",
      pitch: IMAGES_PATH + "/images/microlecture/pitch.png",
      query: IMAGES_PATH + "/images/microlecture/query.png",
      querybg: IMAGES_PATH + "/images/microlecture/querybg.png",
      options: {},
      submitStatus: false,
      queryList: {
        typeConfig: [],
      },
    };
  },
  created() {
    this.options = this.$route.query;
    this.getquerys();
  },
  methods: {
    input_ot(e) {
      let { index, key } = e.currentTarget.dataset;
      console.log("输入了", index, key, e.detail.value);
      this.queryList.typeConfig[index].options[key].option = e.detail.value;
      console.log("赋值", this.queryList.typeConfig[index].options[key].option);
    },
    // 选择题目
    changeItem(itemInfo, professionitem) {
      if (this.submitStatus) return;
      const { id } = itemInfo; // 题目信息---题目ID

      const { id: ids } = professionitem; //选项ID

      let list = this.queryList.typeConfig;
      list.forEach((item, index) => {
        console.log("item。sub_type", item.sub_type);
        if (item.id === id) {
          if (item.options != null) {
            list[index].options.forEach((e, i) => {
              if (e.id === ids) {
                e.isShow = !e.isShow;
              } else {
                if (item.sub_type == 1) e.isShow = false;
              }
            });
          }
        }
      });
      this.queryList.typeConfig = list;
    },
    // 提交问卷
    // type 4 是测试，answers=题id:选项id-选项id:其它内容,题id:选项id:其它内容
    // type 2 是调研  answers=题id:选项id-选项id:其它内容,题id:选项id:其它内容
    submit() {
      if (this.submitStatus) return;
      var list = this.queryList;
      for (let i = list.typeConfig.length; i > 0; i--) {
        list.typeConfig[i - 1].isShowindex = 0;
        for (let k = list.typeConfig[i - 1].options.length; k > 0; k--) {
          console.log(list.typeConfig[i - 1].options[k - 1].isShow);
          if (list.typeConfig[i - 1].options[k - 1].isShow) {
            list.typeConfig[i - 1].isShowindex++;
          }
        }
        if (list.typeConfig[i - 1].isShowindex < 1) {
          return uni.showToast({
            title: "请确保每道题都已勾选（包括简答题）",
            icon: "none",
          });
        }
      }
      let options = this.options;
      options.answers = list;
      // 提交问卷拼数据给后端
      let answersStr = "";
      let nonNull = true;
      list.typeConfig.forEach((item, idx) => {
        console.log("item", JSON.stringify(item), idx);
        if (idx != 0) answersStr = answersStr + ",";

        answersStr = answersStr + item.id + ":";
        let mao_idx = 0;
        item.options.forEach((itemm, idxx) => {
          if (itemm.isShow === true) {
            answersStr =
              mao_idx == 0
                ? answersStr + itemm.id
                : item.otherOption == "1" && idxx == item.options.length - 1
                ? answersStr
                : answersStr + "-" + itemm.id;

            // 添加自己输入的值
            if (item.otherOption == "1" && idxx == item.options.length - 1) {
              answersStr = answersStr + ":" + itemm.option;
            }
            ++mao_idx;
            if (
              idxx == item.options.length - 1 &&
              item.otherOption == "1" &&
              itemm.option == ""
            )
              nonNull = false;
          }
        });
      });
      options.answers = answersStr;
      console.log("options.answers", options.answers);
      if (!nonNull) {
        uni.showToast({
          title: "您已勾选简答题,请输入内容后再提交",
          icon: "none",
        });
        return;
      }
      sectionComplete(options).then((res) => {
        console.log(res);
        if (res.code == 200) {
          uni.showToast({
            title: res.message,
            icon: "none",
            duration: 1500,
          });
          this.submitStatus = true;
        }
      });
    },
    // 获取问卷信息
    getquerys() {
      sectionInfo(this.options).then((res) => {
        console.log("res.result.typeConfig", res.result.typeConfig);
        let arr = [];
        for (let i in res.result.typeConfig) {
          console.log("i", i);
          arr.push(res.result.typeConfig[i]);
        }
        res.result.typeConfig = arr;
        res.result.typeConfig.forEach((item, index) => {
          let sub_type = 0; // 1 单选, 2 多选
          item.unselected = false;
          if (item.options != null) {
            item.options.forEach((e) => {
              e.isShow = false;
            });
          }
          if (item.otherOption == 1) {
            sub_type += 1;
            let obj = {
              id: "",
              option: "可勾选后输入您的观点",
              isShow: false,
            };
            if (item.options.length == 0) {
              obj = {
                id: "",
                option: "请先勾选后再作答",
                isShow: false,
              };
            }
            item.options.push(obj);
          }
          item.options.forEach((itemm) => {
            if (itemm.option_right == 1) sub_type += 1;
          });
          console.log("sub_type", sub_type);
          item.sub_type = sub_type;
        });
        this.queryList = res.result;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
}

input {
  border-bottom: 1px solid #d0d0d0;
  border-radius: 6px;
  font-size: 24px;
}

.checkedImg img {
  z-index: 2;
}

.kuangBg {
  width: 110%;

  position: absolute;
  z-index: 0;
  left: -5%;
}

.containent {
  width: 100%;
  background: #f6f6f6;
}

.bannerContainer {
  position: relative;
}

.containent .banner {
  width: 100%;
  height: 438px;
  position: relative;
}

.containent .person {
  position: absolute;
  top: 120px;
  left: 70px;
  display: flex;
  align-items: flex-end;
}

.person .avaUrl {
  width: 92px;
  height: 92px;
  margin-right: 16px;
}

.person .nicName {
  font-size: 52px;
  font-weight: bold;
  color: #481c87;
}

.nicName div:nth-child(2) {
  font-size: 24px;
  font-weight: 400;
}

.title {
  font-size: 34px;
  font-weight: bold;
  color: #481c87;
  width: 80%;
  margin: 20px auto;
}

.main {
  width: 648px;
  min-height: 50vh;
  margin: 0 auto 40px;
  position: relative;
  top: -150px;
}

.items {
  width: 100%;
  background: #fff;
  border-radius: 10px;
  padding-bottom: 20px;
  margin-bottom: 16px;
}

.items .title {
  display: flex;
  box-sizing: border-box;
  padding: 12px 20px 10px;
  width: 100%;
  background: url("https://oss.consultech.com.cn/mkyzd/images/images/microlecture/titlebg.png")
    no-repeat;
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: 0 100%;
  margin-bottom: 20px;
  font-size: 32px;
  color: #481c87;
}

.opt_on {
  border: 1px solid #aacd22;
  border-radius: 10px;
}

.items .opt {
  width: 90%;
  margin: 20px auto;
  padding: 5px;
  font-size: 24px;
  color: #5e5e5e;
  text-align: left;
  display: flex;
  align-items: center;
  position: relative;

  .check {
    width: 34px;
    height: 32px;
    position: relative;
    margin-right: 30px;
  }

  .checked {
    width: 40px;
    height: 34px;
    position: absolute;
    left: 4px;
    // bottom: 6px;
    overflow: visible;
  }

  img {
    overflow: visible;
  }
}

.submit {
  width: 248px;
  height: 80px;
  margin: 100px auto;
  box-shadow: 0px 14px 20px 0px #c2c2c2;
  color: #fff;
  background-color: #d81680;
  line-height: 80px;
  text-align: center;
  border-radius: 10px;
}

.tips {
  position: absolute;
  right: 0px;
  margin-top: 0px;
  color: #b8b8b8;
  font-size: 22px;
}
</style>
